const VERSION = "6.1.6";
export {
  VERSION
};
